import apiService from "./ApiService"
import { createQS } from "./Utils"

class TipoAnexoCruzamentoService {
  async get(termo, pagina) {
    try {
      const qs = createQS({ termo, pagina })
      return await apiService.get('tipo-anexo-cruzamento?' + qs)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getById(id) {
    try {
      return await apiService.get('tipo-anexo-cruzamento/' + id)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async create(data) {
    try {
      return await apiService.post('tipo-anexo-cruzamento', data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async update(id, data) {
    try {
      return await apiService.put('tipo-anexo-cruzamento/' + id, data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async delete(id) {
    try {
      return await apiService.delete('tipo-anexo-cruzamento/' + id)
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }
}

const tipoAnexoCruzamentoService = new TipoAnexoCruzamentoService()
export default tipoAnexoCruzamentoService
